<template>
  <div>
    <form @submit.prevent="submit">
      <b-row>
        <b-col sm="12"> </b-col>

        <b-col sm="6">
          <b-form-group>
            <label>Número de factura <span style="color: red">(Requerido)</span></label>
            <b-form-input
              type="text"
              :state="$v.boarding.invoice_number.$dirty ? !$v.boarding.invoice_number.$error : null"
              v-model="$v.boarding.invoice_number.$model"
              placeholder=""
            >
            </b-form-input>
          </b-form-group>

          <b-form-group>
            <label>Divisa <span style="color: red">(Requerido)</span></label>
            <b-form-select
              :state="$v.boarding.currency.$dirty ? !$v.boarding.currency.$error : null"
              v-model="$v.boarding.currency.$model"
            >
              <option value="">Seleccione</option>
              <option value="USD">USD</option>
              <option value="EUR">EUR</option>
              <option value="CNY">CNY</option>
              <option value="GBP">GBP</option>
            </b-form-select>
          </b-form-group>

          <b-form-group>
            <label>Modalidad de venta <span style="color: red">(Requerido)</span></label>
            <b-form-select
              :state="$v.boarding.sale_mode.$dirty ? !$v.boarding.sale_mode.$error : null"
              v-model="$v.boarding.sale_mode.$model"
            >
              <option value="">Seleccione</option>
              <option value="Consignacion libre">Consignacion libre</option>
              <option value="Bajo condicion">Bajo condicion</option>
              <option value="Precio Firme">Precio Firme</option>
              <option value="Minimo garantizado">Minimo garantizado</option>
              <option value="Muestra">Muestra</option>
            </b-form-select>
          </b-form-group>

          <b-form-group>
            <label>Clausula de venta <span style="color: red">(Requerido)</span></label>
            <b-form-select
              :state="$v.boarding.sale_clause.$dirty ? !$v.boarding.sale_clause.$error : null"
              v-model="$v.boarding.sale_clause.$model"
            >
              <option value="">Seleccione</option>
              <option value="CIF">CIF</option>
              <option value="FOB">FOB</option>
              <option value="FOT">FOT</option>
              <option value="CNF">CNF</option>
              <option value="DAP">DAP</option>
              <option value="FCA">FCA</option>
              <option value="C&F">C&F</option>
              <option value="DPU">DPU</option>
              <option value="ExWorks">ExWorks</option>
              <option value="Muestra">Muestra</option>
            </b-form-select>
          </b-form-group>

          <b-form-group>
            <label>Modo de carga <span style="color: red">(Requerido)</span></label>
            <b-form-select
              :state="$v.boarding.freight_mode.$dirty ? !$v.boarding.freight_mode.$error : null"
              v-model="$v.boarding.freight_mode.$model"
            >
              <option value="">Seleccione</option>
              <option value="Prepaid">Prepaid</option>
              <option value="Collect">Collect</option>
              <option value="Muestra">Muestra</option>
            </b-form-select>
          </b-form-group>
        </b-col>

        <b-col sm="6">
          <b-form-group>
            <label>Fecha de factura <span style="color: red">(Requerido)</span></label>
            <datetime
              type="date"
              auto
              :state="$v.boarding.invoice_date.$dirty ? !$v.boarding.invoice_date.$error : null"
              v-model="$v.boarding.invoice_date.$model"
              required
              :minute-step="10"
              aria-describedby="input-inputFechaTermino-live-feedback"
              input-class="form-control"
              class="theme-orange"
            >
            </datetime>
          </b-form-group>

          <b-form-group>
            <label>Formulario de pago <span style="color: red">(Requerido)</span></label>
            <b-form-select
              :state="$v.boarding.payment_form.$dirty ? !$v.boarding.payment_form.$error : null"
              v-model="$v.boarding.payment_form.$model"
            >
              <option value="">Seleccione</option>
              <option value="Pago Internacional">Pago Internacional</option>
            </b-form-select>
          </b-form-group>

          <b-form-group label="Número PO">
            <b-form-input
              type="text"
              :state="$v.boarding.po_number.$dirty ? !$v.boarding.po_number.$error : null"
              v-model="$v.boarding.po_number.$model"
              placeholder=""
            >
            </b-form-input>
          </b-form-group>

          <b-form-group>
            <label>Flete <span style="color: red">(Requerido)</span></label>
            <b-form-input
              type="text"
              :state="$v.boarding.freight.$dirty ? !$v.boarding.freight.$error : null"
              v-model="$v.boarding.freight.$model"
              v-on:keyup="inputSoloNumeroDecimal"
              placeholder=""
            >
            </b-form-input>
          </b-form-group>

          <b-form-group>
            <label>Seguro <span style="color: red">(Requerido)</span></label>
            <b-form-input
              type="text"
              :state="$v.boarding.insurance.$dirty ? !$v.boarding.insurance.$error : null"
              v-model="$v.boarding.insurance.$model"
              v-on:keyup="inputSoloNumeroDecimal"
              placeholder=""
            >
            </b-form-input>
          </b-form-group>
        </b-col>

        <b-col sm="12">
          <b-form-group label="Nota">
            <b-form-textarea
              type="text"
              :state="$v.boarding.note.$dirty ? !$v.boarding.note.$error : null"
              v-model="$v.boarding.note.$model"
              rows="3"
              max-rows="6"
              placeholder=""
            >
            </b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
    </form>
  </div>
</template>

<script>
import { required, numeric, minLength, between } from "vuelidate/lib/validators";

export default {
  name: "formInformacionComercial",
  props: ["boarding"],
  data() {
    return {};
  },
  validations: {
    boarding: {
      invoice_number: { required },
      invoice_date: { required },
      sale_mode: { required },
      sale_clause: { required },
      freight_mode: { required },
      payment_form: { required },
      currency: { required },
      po_number: {},
      freight: { required },
      insurance: { required },
      note: {}
    }
  },
  mounted() {
    this.loadDataForm();
  },
  methods: {
    saveForm() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return 0;
      } else {
        return 1;
      }
    },
    loadDataForm() {
      console.log("");
    },
    submit() {},
    inputSoloNumero(event) {
      event.target.value = event.target.value.replace(/[^0-9]/, "");
    },
    inputSoloNumeroDecimal(event) {
      event.target.value = event.target.value.replace(/[^0-9.]/, "");
    }
  },
  beforeMount() {}
};
</script>

<style scoped></style>
